import { render, staticRenderFns } from "./UploadPage.vue?vue&type=template&id=735743ef&scoped=true&"
import script from "./UploadPage.vue?vue&type=script&lang=ts&"
export * from "./UploadPage.vue?vue&type=script&lang=ts&"
import style0 from "./UploadPage.vue?vue&type=style&index=0&id=735743ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735743ef",
  null
  
)

export default component.exports